import { Page, PageBody, PageHeader } from '@saas-ui-pro/react'
import { AppShell } from '@saas-ui/react'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { partnerPicker } from '~/atoms/partnerPicker'
import PageBanner, { EnvType } from '~/layout/PageBanner'
import SidebarLayout, { LinkItemProps } from '~/layout/SidebarLayout'
import { supabase } from '~/utils/supabaseClient'

const LoadingPage = () => (
  <Page isLoading>
    <PageHeader title="Loading..." />
    <PageBody />
  </Page>
)

const PartnerGuard = ({ children }: { children: React.ReactNode }) => {
  const partner = useRecoilValue(partnerPicker)
  if (!partner) {
    return <LoadingPage />
  }
  return <>{children}</>
}

type LayoutProps = {
  sidebarLinks: Array<LinkItemProps>
}

const Layout = ({ sidebarLinks }: LayoutProps) => {
  let env: EnvType = 'prod'
  switch (window.location.hostname) {
    case 'staging.hub.artic.works':
      env = 'staging'
      break
    case 'localhost':
      env = 'dev'
      break
  }
  const railwayPrRegex = /artic-hub-artic-hub-pr-.*\.up\.railway\.app/
  if (railwayPrRegex.test(window.location.hostname)) {
    env = 'staging'
  }
  return (
    <AppShell
      height="$100vh"
      sidebar={<SidebarLayout links={sidebarLinks} logout={() => supabase.auth.signOut()} />}
      navbar={<PageBanner env={env} />}
    >
      <Suspense fallback={<LoadingPage />}>
        <PartnerGuard>
          <Outlet />
        </PartnerGuard>
      </Suspense>
    </AppShell>
  )
}

export default Layout
